export const REMINDER_TOKEN = '@remind';
export const NOTE_TOKEN = '@note';

export const isExactReminderStart = (text: string) => text === REMINDER_TOKEN || text.startsWith(`${REMINDER_TOKEN} `);
export const isExactNoteStart = (text: string) => text === NOTE_TOKEN || text.startsWith(`${NOTE_TOKEN} `);

export const mentionRegex = /@\[\{([^}]+)\}\]/g;

const REMINDER_PREFIX_REGEX = /^@remin\w*/i;
const NOTE_PREFIX_REGEX = /^@not\w*/i;

export const startsWithPartialReminder = (text: string) => REMINDER_PREFIX_REGEX.test(text);
export const startsWithPartialNote = (text: string) => NOTE_PREFIX_REGEX.test(text);

export const removeNoteReminderToken = (text: string) =>
  text.replace(REMINDER_PREFIX_REGEX, '').replace(NOTE_PREFIX_REGEX, '');
